import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { PackagesSelectors } from 'src/app/features/packages/store/selectors';

import { FaqService } from '../../services/faq.service';
import { HelpFaqActions } from '../actions';

@Injectable()
export class HelpFaqEffects {
  loadFaqs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HelpFaqActions.LoadFaqs),
      withLatestFrom(this.store.pipe(select(PackagesSelectors.getActivePackageGuid))),
      filter(([_, packageGuid]) => !!packageGuid),
      switchMap(([_, packageGuid]) =>
        this.faqService.getFaqs(packageGuid).pipe(
          map((faqData) => HelpFaqActions.LoadFaqsSuccess({ payload: { faqData } })),
          catchError((err) =>
            of(
              HelpFaqActions.LoadFaqsFailure({
                payload: { error: err?.message ?? 'Failed to load FAQ data' },
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly faqService: FaqService
  ) {}
}
